import { useState, useEffect } from 'react'

export const usePreloader = () => {
  // Start with isLoading true by default
  const [isLoading, setIsLoading] = useState(true)
  
  // Only use this effect on client-side
  useEffect(() => {
    // Only check storage on client-side
    if (typeof window === 'undefined') return

    // Force the preloader to show on first visit, then set the flag
    const hasShownPreloader = localStorage.getItem('hasShownPreloader') === 'true'
    
    if (hasShownPreloader) {
      // If we've already shown the preloader once, don't show it again
      setIsLoading(false)
    }
    
    // We're intentionally not setting the flag here - we'll do that in completeLoading
  }, [])
  
  const completeLoading = () => {
    setIsLoading(false)
    
    // Mark that we've shown the preloader
    if (typeof window !== 'undefined') {
      localStorage.setItem('hasShownPreloader', 'true')
    }
  }
  
  return {
    isLoading,
    completeLoading
  }
}

export default usePreloader 